import { FlexPlacement } from "../FlexPlacement";

export const commonPlacementComponents = {
  "flex-placement": FlexPlacement,
};
